var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupPolitikaKolacica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165 165",
    style: {
      enableBackground: "new 0 0 165 165"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6E5DD8;}\n\t.st1{fill:#FA7268;}\n\t.st2{fill:#AA6276;}\n\t.st3{fill:#159497;}\n\t.st4{fill:none;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st6{fill:#231F20;}\n\t.st7{fill:none;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st8{fill:#FFFFFF;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st10{fill:#6E5DD8;stroke:#FA7268;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st13{fill:#FFFFFF;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st16{fill:#FFFFFF;stroke:#6E5DD8;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:#FFFFFF;stroke:#159497;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st19{fill:#FFFFFF;stroke:#AA6276;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st20{fill:#FA7268;stroke:#231F20;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st22{fill:#FA7267;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.8,65.7c-2.9,1.1-6.1,1.6-9.4,1.6c-13.2,0-24.3-9.2-27.1-21.6c-0.2,0-0.5,0-0.7,0 c-11.9,0-21.6-9.7-21.6-21.6c0-2.8,0.5-5.4,1.5-7.8c-31.5,6.1-55.4,33.8-55.4,67.2c0,37.8,30.6,68.4,68.4,68.4s68.4-30.6,68.4-68.4 c0-1.3,0-2.5-0.1-3.8C139.5,79.7,130.5,74,125.8,65.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 47.9,
    cy: 64.5,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 120.4,
    cy: 96.3,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 78.1,
    cy: 90.2,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 95.9,
    cy: 132.1,
    r: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 41.8,
    cy: 102.4,
    r: 6.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupPolitikaKolacica);
export default __webpack_public_path__ + "static/media/Signup-politika_kolacica.8e0db085f2bfa40a5493211724d935d8.svg";
export { ForwardRef as ReactComponent };